export default __webpack_public_path__ + "static/media/fa-light-300.95914d2b.ttf";